module.exports = __webpack_public_path__ + "static/media/slakteweb-logo@2x.1e07cad3.svg";